import { BaseFetch } from "../main-model"
export default class AcademicCalendarModel extends BaseFetch {
    getAcademicCalendarBy = (data) =>
    this.authFetch({
      url: "academic-calendar/getAcademicCalendarBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getAcademicCalendarById = (data) =>
    this.authFetch({
      url: "academic-calendar/getAcademicCalendarById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAcademicCalendar = (data) =>
    this.authFetch({
      url: "academic-calendar/insertAcademicCalendar",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAcademicCalendarById = (data) =>
    this.authFetch({
      url: "academic-calendar/updateAcademicCalendarById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAcademicCalendarById = (data) =>
    this.authFetch({
      url: "academic-calendar/deleteAcademicCalendarById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
